import EventGenerateOption from '@/screens/EventGenerateOption';

export default function PrivateEventGenerateOptionRoute() {
  return <EventGenerateOption />;
}
